import React from 'react';

export default function AmountInput({ value, onChange, disabled, step = '0.01', min = 0, placeholder = '0.00', className, style }) {
  function adjust(delta) {
    const current = parseFloat(value) || 0;
    const next = Math.max(min, Math.round((current + delta) * 100) / 100);
    onChange(next === 0 ? '' : String(next));
  }

  return (
    <div className={`amount-input-wrap${className ? ' ' + className : ''}`} style={style}>
      <input
        type="number"
        className="amount-input-field"
        min={min}
        step={step}
        placeholder={placeholder}
        value={value}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
      />
      <div className="amount-input-arrows">
        <button type="button" className="amount-arrow up" onClick={() => adjust(1)} disabled={disabled} aria-label="Augmenter" tabIndex={-1}>
          <svg width="9" height="9" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
            <path d="M18 15l-6-6-6 6"/>
          </svg>
        </button>
        <button type="button" className="amount-arrow down" onClick={() => adjust(-1)} disabled={disabled} aria-label="Diminuer" tabIndex={-1}>
          <svg width="9" height="9" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
            <path d="M6 9l6 6 6-6"/>
          </svg>
        </button>
      </div>
    </div>
  );
}
